const capitalize = ([first, ...rest]) => first.toUpperCase() + rest.join('');

export default capitalize;
